import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export async function createAgent(payload) {
  const { data } = await axios.post(`${API}/agents`, payload);
  return data;
}

export async function listAgents() {
  const { data } = await axios.get(`${API}/agents`);
  return data;
}

export async function getAgent(username) {
  const { data } = await axios.get(`${API}/agents/${username}`);
  return data;
}
